import { render, staticRenderFns } from "./commentFooter.vue?vue&type=template&id=0ef812c8&scoped=true&"
import script from "./commentFooter.vue?vue&type=script&lang=js&"
export * from "./commentFooter.vue?vue&type=script&lang=js&"
import style0 from "./commentFooter.vue?vue&type=style&index=0&id=0ef812c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef812c8",
  null
  
)

export default component.exports